module.exports = __webpack_public_path__ + "img/picture_29.c9109b27.png";